<div class="card-body">
    <div id="apex-negative-area-chart"></div>
</div>